import { Button, Paragraph, SectionTitle } from "../components/typography.jsx";
import {
  Headline,
  ImageHeader,
  MainContent,
  Section,
  TwoColumns,
} from "../templates/common/Components.jsx";
import { color, context, is, styled, theme } from "../util/style.js";

import Container from "../templates/common/Container.jsx";
import LoggedInTemplate from "../templates/LoggedInTemplate.jsx";
import { colors } from "../templates/theme.jsx";
import header from "../img/remplacement_bandeau.jpg";
import header2x from "../img/remplacement_bandeau@2x.jpg";
import headerMobile from "../img/remplacement_bandeau_mobile.jpg";
import headerMobile2x from "../img/remplacement_bandeau_mobile@2x.jpg";
import operationRemplacementPhoto1 from "../img/operemp_photo1.jpg";
import operationRemplacementPhoto2 from "../img/operemp_photo2.jpg";

const HeadlineGreen = styled(Headline)`
  h1 {
    color: ${color("green2")};
  }
`;

const BlockGreen = styled.div`
  background: #ecf4ed;
  border-radius: ${theme("border-radius")};
  padding: ${theme("padding-container")};

  ul {
    li {
      margin-left: 1.5em;
    }
  }

  ${Button} {
    margin-top: ${theme("padding-container")};
  }

  ${context("for-tablet-portrait")`
    padding: ${theme("padding-container-mobile")};
    ${Button} {
      margin-top: ${theme("padding-container-12px")};
    }
  `}
`;

export default function OperationRemplacement() {
  return (
    <LoggedInTemplate title="Opération remplacement">
      <ImageHeader
        image={header}
        image2x={header2x}
        imageMobile={headerMobile}
        imageMobile2x={headerMobile2x}
        icon="hands-line"
        label="Opération remplacement"
      />
      <MainContent>
        <HeadlineGreen
          title={
            <div>
              <span style={{ display: "inline-block" }}>
                Opération remplacement :{" "}
              </span>
              <span style={{ display: "inline-block" }}>
                un nouveau souffle pour votre activité !
              </span>
            </div>
          }
        />

        <Container>
          <TwoColumns
            aside={
              <img
                src={operationRemplacementPhoto1}
                alt=""
                style={{ borderRadius: "8px" }}
              />
            }
          >
            <Paragraph>
              <strong>
                Après plus de 15 ans de fonctionnement pour une pompe à chaleur,
                une chaudière ou un radiateur électrique, leurs performances ne
                sont plus comparables aux standards actuels.
              </strong>
            </Paragraph>
            <Paragraph>
              C'est le bon moment pour proposer à vos clients de remplacer leur
              équipement actuel (chaudière à gaz, radiateur électrique ou
              ancienne pompe à chaleur) par la nouvelle génération de pompe à
              chaleur Daikin !
            </Paragraph>
            <Paragraph>
              Vos clients vous connaissent déjà à travers l'installation d'un
              ancien équipement il y a au moins 15 ans. Ils sont donc prêts à
              entendre votre proposition de remplacement. Avec les nouvelles
              générations de pompes à chaleur Daikin, vous leur apporterez plus
              de confort, d’économies et une tranquillité d'esprit grâce à
              l'option garantie 10 ans pièces.
            </Paragraph>
            <Paragraph>
              <strong>
                Saisissez cette opportunités pour développer votre activité !
              </strong>
            </Paragraph>
          </TwoColumns>
        </Container>

        <Section>
          <Container>
            <HeadlineGreen
              title={
                <div>
                  <span style={{ display: "inline-block" }}>
                    Pour vous accompagner{" "}
                  </span>
                  <span style={{ display: "inline-block" }}>
                    dans cette opération
                  </span>
                </div>
              }
            >
              Pour vous accompagner dans cette opération et vous garantir un
              maximum d'efficacité, Daikin met à votre disposition une
              présentation complète de l'opération ainsi qu'un ensemble d'outils
              simples, pratiques et prêts à l'emploi :
            </HeadlineGreen>
            <TwoColumns
              aside={
                <img
                  src={operationRemplacementPhoto2}
                  alt=""
                  style={{ borderRadius: "8px" }}
                />
              }
            >
              <BlockGreen>
                <ul>
                  <li>Flyer</li>
                  <li>Emailing pour vos clients et/ou prospects</li>
                  <li>Bandeau signature d’email</li>
                  <li>Un PDF de présentation de l'opération</li>
                  <li>Un document avec des éléments de langage</li>
                </ul>

                <Button
                  to={
                    "https://www.reseau-ech-daikin.fr/wp-content/uploads/2025/10/kit-de-remplacement.zip"
                  }
                  color={colors.green2}
                >
                  Télécharger le kit
                </Button>
              </BlockGreen>
            </TwoColumns>
          </Container>
        </Section>
      </MainContent>
    </LoggedInTemplate>
  );
}
